import React, { useState, useEffect, MouseEvent } from "react";
import Post from "./Post";
import { fetchPublicPosts, BlogPost } from "../../api/postapi";
import "../../scss/posts.scss";
import { useI18n } from "../../i18n/I18nProvider";

const PostsComponent: React.FC = () => {
  const { t, language } = useI18n();
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const handleMouseMove = (e: MouseEvent<HTMLElement>) => {
    const target = e.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    target.style.setProperty("--mouse-x", `${x}px`);
    target.style.setProperty("--mouse-y", `${y}px`);
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
  };

  useEffect(() => {
    let isMounted = true;
    const loadPosts = async () => {
      setLoading(true);
      setError(null);
      try {
        const fetchedPosts = await fetchPublicPosts(1, 3);
        if (isMounted) setPosts(fetchedPosts);
      } catch (err) {
        if (isMounted)
          setError(
            err instanceof Error ? err.message : "Wystąpił błąd krytyczny"
          );
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadPosts();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="posts-section" onMouseMove={handleMouseMove}>
      <div className="grid-overlay" aria-hidden="true" />
      <div className="grid-glow" aria-hidden="true" />

      <div className={`posts-container posts-container--count-${posts.length}`}>
        {loading && (
          <div
            style={{
              gridColumn: "1 / -1",
              textAlign: "center",
              color: "#00FF41",
              padding: "5rem",
              fontFamily: "monospace",
            }}
          >
            <h2>{t("posts_loading_title")}</h2>
            <div
              className="spinner"
              style={{
                margin: "0 auto",
                width: "40px",
                height: "40px",
                border: "3px solid rgba(0,255,65,0.3)",
                borderTopColor: "#00FF41",
                borderRadius: "50%",
                animation: "postsSpinner 1s linear infinite",
              }}
            />
          </div>
        )}

        {error && (
          <div
            style={{
              gridColumn: "1 / -1",
              textAlign: "center",
              color: "#ff4444",
              padding: "5rem",
              fontFamily: "monospace",
            }}
          >
            <h2>{t("posts_error_prefix")}{error}</h2>
          </div>
        )}

        {!loading &&
          !error &&
          posts.map((post) => (
            <Post
              key={post.id}
              id={post.id}
              title={language === "en" && post.title_eng ? post.title_eng : post.title_pl}
              content={language === "en" && post.desc_eng ? post.desc_eng : post.desc_pl}
              imageUrl={`https://cybernews.wsiz.edu.pl/images/cc_posts/${post.id}.png`}
              link={`/aktualnosci/${post.id}`}
              data={formatDate(post.created_at)}
            />
          ))}
      </div>
    </section>
  );
};

export default PostsComponent;